export const WEB_REFS = [
  {
    doc_version: '0919',
    file_name: 'VMFairProcessingNotice.pdf',
    content_type: 'PDF',
    reason: 'DATA PROTECTION'
  },
  {
    doc_version: '0219',
    file_name: 'VMTandCs.pdf',
    content_type: 'PDF',
    reason: 'DOCUMENTATION'
  },
  {
    doc_version: '0420',
    file_name: 'VMTariff.pdf',
    content_type: 'PDF',
    reason: 'DOCUMENTATION'
  }
];

const DATA_PROVISIONING_KEY = 'data protection';
const DATA_PROVISIONING_VERSION = 'J';
export const getDocumentPayload = isReview => {
  return isReview
    ? WEB_REFS.map(doc => ({
        reason: doc.reason,
        name: doc.file_name,
        version:
          doc.reason && doc.reason.toLowerCase() === DATA_PROVISIONING_KEY
            ? DATA_PROVISIONING_VERSION
            : doc.doc_version,
        content_type: doc.content_type,
        consent: 'Y',
        timestamp: new Date().toISOString()
      }))
    : [];
};
